import * as React from 'react';
import styled from 'styled-components';

interface Props {
  children: any;
  disablePadding?: boolean;
  style?: React.CSSProperties;
}

export default class NavDropdown extends React.Component<Props, {}> {
  render() {
    const { children } = this.props;

    let disablePadding;

    if (this.props.disablePadding === true) {
      disablePadding = true;
    } else {
      disablePadding = false;
    }

    return (
      <NavDropdownComponent
        style={Object.assign(
          {},
          {
            padding: disablePadding ? '0' : '20px',
          },
          this.props.style,
        )}
      >
        {' '}
        {children}{' '}
      </NavDropdownComponent>
    );
  }
}

const NavDropdownComponent = styled.div`
  transition: all 0.3s ease;
`;
